import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
//import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { FaTimes, FaCalendarAlt, FaQuestionCircle } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { collection, getDocs, setDoc, doc, deleteDoc, getDoc, onSnapshot } from 'firebase/firestore';
import { isToday, setHours, setMinutes } from 'date-fns';

const SurveySelectionPopup = ({ onClose, userId, editingSurvey, onSurveyAdded }) => {
  const [surveys, setSurveys] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [triggerDateTime, setTriggerDateTime] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [editingRecord, setEditingRecord] = useState(null); // null if creating
  const now = new Date();

  useEffect(() => {
    fetchSurveys();
  }, []);

  const fetchSurveys = async () => {
    console.log("fetchSurveys called");
    try {
      const surveysRef = collection(db, 'EMA', 'data', 'surveys');
      console.log("Fetching from Firestore collection:", surveysRef.path);
      const snapshot = await getDocs(surveysRef);
      const surveysList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      console.log("Surveys list:", surveysList);
      setSurveys(surveysList);
      console.log("1 surveys array:", surveysList);
      setEditingMode(surveysList);

    } catch (error) {
      console.error('Error fetching surveys:', error);
      setError('Failed to load surveys');
    } finally {
      console.log("fetchSurveys: finished, calling setEditingMode()");
      setIsLoading(false);
    }
  };

  function setEditingMode(surveysArray) {
    console.log("setEditingMode called");
    if (editingSurvey) {
      console.log("editingSurvey:", editingSurvey);
      console.log("surveys array:", surveysArray);
      const matchingSurvey = surveysArray.find(survey => survey.id === editingSurvey.value);
      console.log("matchingSurvey found:", matchingSurvey);
      setSelectedSurvey(matchingSurvey);
      setTriggerDateTime(new Date(editingSurvey.start * 1000));
    } else {
      console.log("No editingSurvey present.");
    }
  }

  function isSameDay(date1, date2) {
    return (
      date1 &&
      date2 &&
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  const handleSurveySelect = async (survey) => {
    console.log('handleSurveySelect called');
    console.log('Selected survey:', survey);
    console.log('Trigger date/time:', triggerDateTime);
    console.log('editingSurvey:', editingSurvey);

    if (!triggerDateTime) {
      setError('Please select a trigger date and time');
      console.warn('No triggerDateTime selected');
      return;
    }

    try {
      const currentTimestamp = Math.floor(Date.now() / 1000);
      const triggerDateTimestamp = Math.floor(new Date(triggerDateTime).getTime() / 1000);

      let recordId, status, mode;
      if (editingSurvey) {
        // Edit mode
        recordId = editingSurvey.id;
        status = editingSurvey.status || "Pending";
        mode = "EDIT";
      } else {
        // Add mode
        recordId = currentTimestamp;
        status = "Pending";
        mode = "ADD";
      }

      const recordsRef = doc(db, `EMA/${userId}/Records`, recordId.toString());
      const data = {
        type: "Survey",
        start: triggerDateTimestamp,
        value: survey.surveyId,
        createdAt: currentTimestamp,
        isConsistent: false,
        status: status,
        title: survey.title
      };

      console.log(`[${mode}] Record ID:`, recordId);
      console.log(`[${mode}] Record Ref:`, recordsRef.path);
      console.log(`[${mode}] Data to be saved:`, data);

      await setDoc(recordsRef, data, { merge: true });

      console.log(`[${mode}] Survey record ${mode === "EDIT" ? "updated" : "added"} successfully!`);
      onSurveyAdded();
      onClose();
    } catch (error) {
      console.error('Error saving survey trigger:', error);
      setError('Failed to save survey trigger');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
      <div className="bg-white rounded-xl shadow-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Select Survey</h2>
            <button
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center bg-gray-50 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>
          </div>

          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-100 rounded-lg">
              <p className="text-red-700">{error}</p>
            </div>
          )}

          {isLoading ? (
            <div className="flex justify-center items-center h-32">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
          ) : (
            <div className="space-y-4">
              {surveys.map((survey) => (
                <div
                  key={survey.id}
                  onClick={() => setSelectedSurvey(survey)}
                  className={`p-4 border rounded-lg cursor-pointer transition-colors ${
                    selectedSurvey?.surveyId === survey.surveyId
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 hover:border-blue-300'
                  }`}
                >
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{survey.title}</h3>
                  <p className="text-gray-600 mb-3 line-clamp-2">{survey.description}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-1">
                      <FaQuestionCircle className="h-4 w-4" />
                      <span>{survey.questions?.length || 0} questions</span>
                    </div>
                    {survey.triggerDateTime && (
                      <div className="flex items-center gap-1">
                        <FaCalendarAlt className="h-4 w-4" />
                        <span>Trigger: {new Date(survey.triggerDateTime.seconds * 1000).toLocaleString()}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {selectedSurvey && (
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Set Trigger Time</h3>
              <DatePicker
                      selected={triggerDateTime ? new Date(triggerDateTime) : null}
                      onChange={(date) => {
                        const time = date.getTime();
                        setTriggerDateTime(time);
                      }}
                      showTimeSelect
                      timeFormat="hh:mm aa"
                      timeIntervals={15}
                      dateFormat="dd-MM-yyyy hh:mm aa"
                      timeCaption="Time"
                      placeholderText="Select date and time"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      minDate={now}
                      minTime={
                        !triggerDateTime || isSameDay(new Date(triggerDateTime), now)
                          ? now
                          : new Date(new Date().setHours(0, 0, 0, 0))
                      }
                      maxTime={new Date(new Date().setHours(23, 45, 0, 0))}
                    />
            </div>
          )}

          <div className="mt-6 flex justify-end gap-4">
            
            <button
              onClick={() => handleSurveySelect(selectedSurvey)}
              disabled={!selectedSurvey || !triggerDateTime}
              className={`px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                (!selectedSurvey || !triggerDateTime) ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {editingSurvey ? 'Done' : 'Add Survey'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveySelectionPopup; 